import { AlertModalLayout, Button } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import { ModalStyled } from './alert-modal.styled';
import { UnsavedChangesScenario } from './alert-modal.types';
import { getCancelButtonText, getConfirmButtonText, getCopyText, getTitleText } from './alert-modal.utils';

export type AlertModalProps = {
  isOpen?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  scenario?: UnsavedChangesScenario;
  /** Additional text used in the modal copy to clarify the specific scenario. For example, see `getTitleText`. */
  description?: string;
};

/**
 * This modal needs to be refactored. See: https://linear.app/neo-tax/issue/NEO-3826/app-wide-alert-modal
 */
export const AlertModal = ({
  description,
  isOpen = false,
  onCancel,
  onConfirm,
  scenario,
}: AlertModalProps): ReactElement => (
  <ModalStyled isOpen={isOpen}>
    {!!scenario && (
      <AlertModalLayout
        title={getTitleText(scenario, description)}
        copy={getCopyText(scenario, description)}
        trailingContent={
          <>
            <Button size="base" variant="action" rounded="regular" onClick={onConfirm}>
              {getConfirmButtonText(scenario)}
            </Button>
            <Button size="base" variant="white" rounded="regular" onClick={onCancel}>
              {getCancelButtonText(scenario)}
            </Button>
          </>
        }
      />
    )}
  </ModalStyled>
);
